import { forwardRef, useMemo } from 'react';

import { css, cx } from '@/styled-system/css';

import { ZillowLogoSVG } from './paths/zillow-logo-paths';
import { ZillowLogoLegacySVG } from './paths/zillow-logo-paths-legacy';
import { zillowLogoRecipe } from './styles/zillow-logo.styles';
import type { ZillowLogoPropsInterface } from './types/zillow-logo.types';

export const ZillowLogo = forwardRef<SVGSVGElement, ZillowLogoPropsInterface>(
  (props: ZillowLogoPropsInterface, forwardedRef) => {
    const {
      className,
      css: cssProp,
      removeTrademark = false,
      showLegacyLogo = false,
      onImpact = false,
      role = 'img',
      ...rest
    } = props;

    const styles = css(zillowLogoRecipe.raw({ onImpact, showLegacyLogo }), cssProp);

    const getViewBox = useMemo(() => {
      let viewBox = removeTrademark ? '0 0 203 44' : '0 0 210 44';

      if (showLegacyLogo) {
        viewBox = removeTrademark ? '0 0 1843 400' : '0 0 1911 400';
      }
      return viewBox;
    }, [showLegacyLogo, removeTrademark]);

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={cx(
          'c11n',
          showLegacyLogo ? 'c11n_zillow-logo__legacy' : 'c11n_zillow-logo',
          styles,
          className,
        )}
        data-c11n-component={showLegacyLogo ? 'ZillowLogo.Legacy' : 'ZillowLogo'}
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        role={role}
        viewBox={getViewBox}
        {...rest}
      >
        <title>Zillow logo</title>
        {showLegacyLogo ? (
          <ZillowLogoLegacySVG removeTrademark={removeTrademark} />
        ) : (
          <ZillowLogoSVG removeTrademark={removeTrademark} />
        )}
      </svg>
    );
  },
);

ZillowLogo.displayName = 'ZillowLogo';
